module.exports = {
      id: "icon-audio-play-store-usage",
      viewBox: "0 0 122 41",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-audio-play-store",
      toString: function () {
        return this.url;
      }
    }